<template>
  <div class="modal-popup">
    <div class="modal fade" id="agencyUserPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="user != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="user.id != null">Kullanıcı Güncelle</h5>
            <h5 class="modal-title title" v-else>Yeni Kullanıcı Yarat</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="roomFrom" autocomplete="off">
                <div class="row">
                  <div class="col-sm-6">
                    <base-edit-input
                        ref="nameInput"
                        v-model="user.name"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Adı'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-edit-input
                        ref="spaceInput"
                        v-model="user.lastName"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Soyadı'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-phone-input
                      v-model="user.phoneNumber"
                      uu-id="userPhoneNumber"
                      :label="'Telefon Numarası'">
                    </base-phone-input>
                  </div>
                  <div class="col-sm-6">
                    <base-text-area-input
                        v-model="user.address"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Adres'">
                    </base-text-area-input>
                  </div>
                  <div class="col-sm-6">
                    <base-edit-input
                        v-model="user.email"
                        :rules="'email'"
                        :label="'Email'"
                        :disabled="user.id != null"
                    >
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-edit-input
                        v-if="user.id == null"
                        v-model="user.password"
                        :rules="'required'"
                        :label="'Parola'">
                    </base-edit-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
          <div class="modal-footer border-top-0 pt-0">
            <button v-if="user.active" @click="deActivedUser" type="button" class="theme-btn theme-btn-danger-rgb" >
              Pasife Çek
            </button>
            <button v-else-if="!user.active" @click="activedUser" type="button" class="theme-btn theme-btn-positive-rgb">
              Aktif et
            </button>
          </div>
          <div class="modal-footer border-top-0 pt-0 flex">
            <button type="button" class="theme-btn theme-btn-danger-rgb" data-dismiss="modal">İptal</button>
            <button v-if="user.id != null" :class="{'disabled' : !formValid}" @click="update" type="button" class="theme-btn">Güncelle</button>
            <button v-if="user.id == null" :class="{'disabled' : !formValid}" @click="create" type="button" class="theme-btn">Kaydet</button>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseEditInput from "../base/BaseEditInput";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
import BaseSelectInput from "../base/BaseSelectInput";
import validationFormUtils from "../../util/validationFormUtils";
import BaseCheckboxInput from "../base/BaseCheckboxInput";
import BasePhoneInput from "../base/BasePhoneInput";
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "AgencyUserDetail",
  components: {BasePhoneInput, BaseCheckboxInput, BaseTextAreaInput, BaseEditInput, BaseSelectInput},
  data:function (){
    return{
      formValid:false
    }
  },
  computed:{
    user:{
      get(){
        return this.$store.getters.getAgencyUser;
      }
    },
    agency:{
      get(){
        return this.$store.getters.getAgency;
      }
    },
  },
  methods:{
    create(){
      if(this.formValid)
        this.$store.dispatch("createUser", this.user).then(response => {
          $("#agencyUserPopup").modal('hide')
          messagePopupManager.showSuccess();
        })
    },
    update(){
      if(this.formValid)
        this.$store.dispatch("updateUser", this.user).then(response => {
          $("#agencyUserPopup").modal('hide');
          $("#agencyPasswordPopup").modal('hide');
          messagePopupManager.showSuccess();
        })
    },
    deActivedUser(){
      messagePopupManager.showQuestion(() => {
        this.$store.dispatch("deActiveUser", this.user);
      },'User will be deactive');
    },
    activedUser(){
      messagePopupManager.showQuestion(() => {
        this.$store.dispatch("activeUser", this.user);
      },'User will be active');
    },
  },
  watch:{
    user:{
      deep:true,
      handler:function () {
         validationFormUtils.checkFormFields(this);
      }
    }
  }
}
</script>

<style scoped>

</style>